import { z } from 'zod';

export const NodeConfigSchemas: Record<string, z.ZodTypeAny> = {
  root: z.object({ scope: z.string(), trigger: z.enum(['on_create', 'on_update', 'on_schedule']) }),

  'cond.field_eq': z.object({ field: z.string(), op: z.literal('='), value: z.unknown() }),
  'cond.field_cmp': z.object({
    field: z.string(),
    op: z.enum(['>', '<', '>=', '<=']),
    value: z.number(),
  }),
  'cond.in_list': z.object({ field: z.string(), values: z.array(z.unknown()) }),
  'cond.time_window': z.object({
    field: z.string(),
    window: z.enum(['last_7_days', 'last_30_days', 'today', 'this_week', 'this_month']),
  }),

  'logic.and': z.object({}),
  'logic.or': z.object({}),
  'logic.not': z.object({}),

  'flow.if': z.object({}),
  'flow.sequence': z.object({}),
  'flow.switch': z.object({ field: z.string() }),

  'act.notify_user': z.object({ user_id: z.string().uuid() }),
  'act.notify_role': z.object({ role_id: z.string().uuid() }),
  'act.set_field': z.object({ field: z.string(), value: z.unknown() }),
  'act.create_task': z.object({
    title: z.string(),
    assignee_role_id: z.string().uuid().optional(),
  }),
  'act.webhook': z.object({ subscription_id: z.string().uuid() }),
  'act.require_approval': z.object({ approver_role_id: z.string().uuid() }),
};

export function validateNodeConfig(kind: string, config: unknown): boolean {
  const schema = NodeConfigSchemas[kind];
  if (!schema) return false;
  return schema.safeParse(config).success;
}
